import { Info } from "lucide-react";
import { Button } from "./button";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

/** Infobulle « i » pour une description de métrique (texte fourni par le praticien). */
export const NumericMetricDescriptionInfo = ({
  description,
  ariaLabel = "Informations sur cette métrique",
}: {
  description: string | undefined;
  /** Libellé accessible pour le bouton (passer une chaîne traduite depuis l’app). */
  ariaLabel?: string;
}) => {
  const text = description?.trim();
  if (!text) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="text-muted-foreground h-8 w-8 shrink-0"
          aria-label={ariaLabel}
        >
          <Info className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs text-left">
        <p className="text-pretty text-sm">{text}</p>
      </TooltipContent>
    </Tooltip>
  );
};
